var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found wrapper mb-xxl pt-xxl pb-l"},[_c('GHeader',{staticClass:"mb-xl",attrs:{"content":{ title: 'Page non-trouvée', headline: 'Erreur 404' }}}),_c('GAction',{attrs:{"content":{
      label: 'Retourner à l’accueil',
      url: '/',
      modifiers: ['btn', 'gold'],
      icon: 'arrow',
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }